import { columnMap } from '@/utils/constants'
import { DataValidatorService, RegisterStatus, type MembersData } from 'commons'

export class MembersProcess {
  constructor(private dataValidatorService: DataValidatorService) {}

  mergeMembers(newMembers: MembersData[], actualMembers: MembersData[]) {
    let allData: MembersData[] = [...actualMembers]
    const newRows: MembersData[] = []
    let skippedCount = 0

    for (const newRow of newMembers) {
      if (!newRow.columns) continue

      let hasDuplicate = false

      for (const existingRow of actualMembers) {
        const rfcCol = Object.keys(columnMap).find((key) => columnMap[key] === 'taxId')
        const emailCol = Object.keys(columnMap).find((key) => columnMap[key] === 'email')
        const phoneCol = Object.keys(columnMap).find((key) => columnMap[key] === 'phone')

        const newRfc = newRow.columns.find((col) => col.columnName === rfcCol)?.columnValue
        const newEmail = newRow.columns.find((col) => col.columnName === emailCol)?.columnValue
        const newPhone = newRow.columns.find((col) => col.columnName === phoneCol)?.columnValue

        const existingRfc = existingRow.columns?.find(
          (col) => col.columnName === rfcCol,
        )?.columnValue
        const existingEmail = existingRow.columns?.find(
          (col) => col.columnName === emailCol,
        )?.columnValue
        const existingPhone = existingRow.columns?.find(
          (col) => col.columnName === phoneCol,
        )?.columnValue

        if (
          (newRfc && newRfc === existingRfc) ||
          (newEmail && newEmail === existingEmail) ||
          (newPhone && newPhone === existingPhone)
        ) {
          hasDuplicate = true
          break
        }
      }

      if (!hasDuplicate) {
        const validatedRow: MembersData = {
          columns: [
            ...newRow.columns.map((col) => ({
              columnName: col.columnName,
              columnValue: col.columnValue,
              isValid: col.isValid !== undefined ? col.isValid : true,
              isRepeated: col.isRepeated ?? false,
              isDirty: false,
              isOriginalRepeated: col.isOriginalRepeated ?? false,
              type: col.type,
              isVisible: col.isVisible,
              isRequiredInFile: col.isRequiredInFile,
            })),
            {
              columnName: 'Estado del Registro',
              columnValue: RegisterStatus.NOT_REGISTERED,
              isValid: true,
              isRepeated: false,
              isDirty: false,
              isOriginalRepeated: false,
            },
          ],
        }
        newRows.push(validatedRow)
      } else {
        skippedCount++
      }
    }

    let inconsistenciesAndErrors = 0

    // If there are no actual members, use only new rows
    // Otherwise, always combine actual members with new rows
    if (actualMembers.length === 0 && newRows.length > 0) {
      allData = [...newRows]
    } else {
      allData = [...actualMembers, ...newRows]
    }

    // Always validate allData to ensure isValid is correctly set
    if (allData.length > 0) {
      this.dataValidatorService.validateData(allData)
      inconsistenciesAndErrors = this.countInconsistenciesAndErrors(allData)
    }

    const processResponse: ProcessResponse = {
      allData: allData,
      newRows: newRows,
      duplicatedDataCount: skippedCount,
      inconsistenciesAndErrors,
    }
    return processResponse
  }

  countInconsistenciesAndErrors(data: MembersData[]) {
    let count = 0

    for (const row of data) {
      if (row.columns?.some((col) => !col.isValid || col.isRepeated)) count++
    }

    return count
  }
}

export type ProcessResponse = {
  allData: MembersData[]
  newRows: MembersData[]
  duplicatedDataCount: number
  inconsistenciesAndErrors: number
}
